<div class="page-container list-page mt-6 mb-6 pt-4">
    <h1 class="title is-1 pb-3">Education & Training</h1>
    <form [formGroup]="form" (ngSubmit)="search()">
        <div class="columns no-space">
            <div class="column no-space is-10 is-multiline">
                <div class="columns">
                    <div class="field column">
                        <label for="course-text-input">Search by text</label>
                        <div class="control is-expanded has-icons-left">
                            <input
                                id="course-text-input"
                                formControlName="extractedText"
                                type="search"
                                class="input"
                                placeholder="Type text to search"
                                aria-label="text to use in education or training search"
                                id="education-and-training-text-input"
                            />
                            <isav-icon icon="search" class="is-small is-left"></isav-icon>
                        </div>
                    </div>
                    <div class="field column">
                        <label for="course-start-date">Start date</label>
                        <div class="control is-expanded">
                            <input
                                id="course-start-date"
                                type="date"
                                class="input"
                                formControlName="startDate"
                            />
                        </div>
                    </div>
                    <div class="field column">
                        <label for="course-end-date">End date</label>
                        <div class="control is-expanded">
                            <input
                                id="course-end-date"
                                type="date"
                                class="input"
                                formControlName="endDate"
                            />
                        </div>
                    </div>
                </div>

                <div class="columns">
                    <div class="field column">
                        <label for="course-organisation">Select organisation</label>
                        <div class="control">
                            <isav-taxonomy-select
                                id="course-organisation"
                                formControlName="organisation"
                                taxonomy="Organisation"
                                placeholder="Select organisation"
                            ></isav-taxonomy-select>
                        </div>
                    </div>
                    <div class="field column">
                        <label for="course-department">Select departments</label>
                        <div class="control">
                            <isav-department-select
                                id="course-department"
                                formControlName="department"
                                [organisationIri]="form.value.organisation"
                                placeholder="Select departments"
                                [multiple]="true"
                            ></isav-department-select>
                        </div>
                    </div>
                    <div class="field column">
                        <label for="course-teaching-country">Select teaching country</label>
                        <div class="control">
                            <isav-taxonomy-select
                                id="course-teaching-country"
                                formControlName="country"
                                taxonomy="Country"
                                placeholder="Select teaching country"
                            ></isav-taxonomy-select>
                        </div>
                    </div>
                </div>

                <div class="columns">
                    <div class="field column">
                        <label for="course-topic">Select topics</label>
                        <div class="control">
                            <isav-taxonomy-select
                                id="course-topic"
                                formControlName="topic"
                                taxonomy="Topic"
                                placeholder="Select topics"
                                [multiple]="true"
                            ></isav-taxonomy-select>
                        </div>
                    </div>
                    <div class="field column">
                        <label for="course-study-field">Select study field</label>
                        <div class="control">
                            <isav-taxonomy-select
                                id="course-study-field"
                                formControlName="studyField"
                                taxonomy="CourseFieldOfStudy"
                                placeholder="Select study field"
                            ></isav-taxonomy-select>
                        </div>
                    </div>
                    <div class="field column">
                        <label for="course-level">Select course level</label>
                        <div class="control">
                            <isav-taxonomy-select
                                id="course-level"
                                formControlName="courseLevel"
                                taxonomy="CourseLevel"
                                placeholder="Select course level"
                            ></isav-taxonomy-select>
                        </div>
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-4 field">
                        <label for="select-course-type">Select course type</label>
                        <div class="control">
                            <isav-select
                                id="select-course-type"
                                formControlName="education"
                                placeholder="Select course type"
                            >
                                <isav-option [value]="'all'">All courses</isav-option>
                                <isav-option [value]="true">Education courses</isav-option>
                                <isav-option [value]="false">Trainings</isav-option>
                            </isav-select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="column is-2 mt-3 vertical-buttons">
                <div class="field">
                    <div class="control">
                        <button
                            isavBtn
                            type="submit"
                            color="success"
                            class="education-and-training-submit"
                        >
                            Search
                        </button>
                    </div>
                </div>

                <div class="field">
                    <div class="control has-text-centered has-text-white">
                        <a (click)="resetForm()" data-testid="resetbtn"> Reset </a>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <isav-mini-content-search *ngIf="searchState | async as searchState" [state]="searchState">
        <div class="columns is-multiline mt-6">
            <ng-container *ngFor="let educationAndTraining of searchState.results.member">
                <isav-landing-card [image]="educationAndTraining.image">
                    <ng-container isavLandingCardCaption>
                        {{ educationAndTraining.startDate | isavDate }} &nbsp;-&nbsp; {{
                        educationAndTraining.endDate | isavDate }}
                    </ng-container>
                    <a
                        isavLandingCardHeading
                        [routerLink]="linkTo(educationAndTraining)"
                        [queryParams]="{ iri: educationAndTraining['@id'] }"
                    >
                        {{ educationAndTraining.title }}
                    </a>
                    <div isavLandingCardFooter class="columns">
                        <div class="column">
                            <strong>Organisation:</strong><br />
                            <isav-taxonomies-names
                                property="title"
                                [iris]="[educationAndTraining.organisation]"
                            ></isav-taxonomies-names>
                        </div>
                        <div class="column">
                            <strong>Field of study:</strong><br />
                            <isav-taxonomies-names
                                [iris]="[educationAndTraining.studyField]"
                            ></isav-taxonomies-names>
                        </div>
                    </div>
                </isav-landing-card>
            </ng-container>
        </div>
    </isav-mini-content-search>
</div>
